export const twoFAOptions = [{
  label: "Forced On",
  value: "FORCE_ON"
}, {
  label: "On",
  value: "ON"
}, {
  label: "Off",
  value: "OFF"
}];